<template>
    <div class="columns">
        <div class="column">
            <div class="control control-left is-pulled-left" @click="prevClick">
                <chev-left-icon class="icon-large"></chev-left-icon>
            </div>
            <div class="control control-right is-pulled-right" @click="nextClick">
                <chev-right-icon class="icon-large"></chev-right-icon>
            </div>
            <figure class="image is-16by9">
                <transition name="fade">
                    <img class="picture" :src="imageLink" :key="imageLink" />
                </transition>
            </figure>
        </div>
    </div>
</template>

<script>
    import ChevLeftIcon from "vue-material-design-icons/ChevronLeft.vue";
    import ChevRightIcon from "vue-material-design-icons/ChevronRight.vue";
    import axios from 'axios';

    const keycodeRight = 39;
    const keycodeLeft = 37;

    export default {
        name: "Carousel",
        components: {
            ChevLeftIcon,
            ChevRightIcon
        },
        data: function() {
            return {
                source: [],
                imageIndex: -1,
                timer: null,
                imageLink: "",
                show: true
            }
        },
        methods: {
            resetTimer: function() {
                clearInterval(this.timer);
                this.timer = setInterval(this.next, 7000);
            },
            next: function() {
                this.imageIndex++;
                if (this.imageIndex > (this.source.length - 1)) {
                    this.imageIndex = 0;
                }
                this.imageLink = this.source[this.imageIndex];
                this.resetTimer();
            },
            nextClick: function() {
                this.next();
            },
            prevClick: function() {
                this.imageIndex--;
                if (this.imageIndex < 0) {
                    this.imageIndex = (this.source.length - 1);
                }
                this.imageLink = this.source[this.imageIndex];
                this.resetTimer();
            }
        },
        mounted: function() {
            // Load images
            axios.get(process.env.VUE_APP_IMAGES_URL + '/carousel/index.json').then(indexJson => {
              indexJson.data.forEach(imageJson => {
                this.source.push(process.env.VUE_APP_IMAGES_URL + imageJson.location);
              });

              // Start slideshow
              this.next();
            });
            
            window.addEventListener("keydown", e => {
                if (keycodeLeft == e.keyCode) {
                    this.nextClick();
                } else if (keycodeRight == e.keyCode) {
                    this.prevClick();
                }
            });
        }
    }
</script>

<style scoped>
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 1s;

    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }

    .column {
        padding: 0;
    }

    .control {
        z-index: 2;
        clear: none;
        height: 100%;
        display: flex;
        align-items: center;
    }

    .material-design-icon.icon-large {
        font-size: 2em;
    }

    .material-design-icon__svg {
        fill: #fff !important;
    }
    
    .material-design-icon__svg:hover {
        cursor: pointer;
    }

    .picture {
        object-fit: cover;
        text-align: center;
        overflow: hidden;
    }

    .picture img {
        width: 100%;
        object-fit: cover;
        transform: scale(1.05);
    }
</style>